import * as React from 'react'
import { cn } from '~/lib/utils'

export type TextareaProps = React.ComponentProps<'textarea'>

/** 멀티라인 입력. 시맨틱 토큰 색·반경을 사용한다. */
function Textarea({ className, ref, ...props }: TextareaProps) {
    return (
        <textarea
            ref={ref}
            data-slot='textarea'
            className={cn(
                'border-input bg-card text-foreground min-h-16 w-full rounded-md border px-3 py-2 text-sm transition-colors',
                'placeholder:text-muted-foreground',
                'focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none',
                'disabled:cursor-not-allowed disabled:opacity-50',
                className
            )}
            {...props}
        />
    )
}

export { Textarea }
